//var ruurl = 'b=' + $.browser.name + '&p=' + $.browser.platform + '&v=' + $.browser.versionNumber + '&f=0' + '&d=' + Number($.browser.desktop || 0);
var ruurl = 'b=' + $.browser.name + '&p=' + $.browser.platform + '&f=0' + '&d=' + Number($.browser.desktop || 0);

function getPlayerReportInfo(id)
{
	var playerInfo = '';

	if(typeof flowplayer === 'undefined' || flowplayer === undefined) {
		playerInfo = 'Player not found';
	} else {
		flowplayer.instances.forEach(function(api) {
			if (api.parentNode.id === id) {
		
				playerInfo += "playerId: " + api.parentNode.id + "\n";
				playerInfo += "version: " + flowplayer.version + "\n";
				playerInfo += "networkState: " + api.networkState + "\n";
				playerInfo += "readyState: " + api.readyState + "\n";
				playerInfo += "src: " + JSON.stringify(api.opts.src) + "\n";
				playerInfo += "playlist: " + api.original_src + "\n";
				playerInfo += "started: " + api.started + "\n";
				playerInfo += "stream_start: " + api.stream_start + "\n";
				playerInfo += "volume: " + api.volume + "\n";
				playerInfo += "muted: " + api.muted + "\n";
				playerInfo += "duration: " + api.duration + "\n";
				playerInfo += "error: " + (api.error ? api.error.message : false) + "\n";
				playerInfo += "html5error: " + (api.error ? JSON.stringify(api.error, ['code', 'message', 'msExtendedCode']) : false) + "\n";
				playerInfo += "ended: " + api.ended + "\n";
				playerInfo += "seeking: " + api.seeking + "\n";
				playerInfo += "webkitDroppedFrameCount: " + api.webkitDroppedFrameCount + "\n";
				playerInfo += "videoWidth: " + api.videoWidth + "\n";
				playerInfo += "videoHeight: " + api.videoHeight + "\n";
			};
		});
	};
	
	//return playerInfo to parent page;
	window.parent.postMessage({
		'event_id': 'player_report', 
		'player': {
			'id': id,
			'info': playerInfo,
		}
	},'*');
}
